import GlobalContextProvider from './src/scripts/GlobalContextProvider';

// Font
import '@eon-ui/eon-ui-font-brixsans';

// Styles
import './src/styles/main.css';
import './node_modules/@eon-ui/eon-ui-components/dist/eon-ui-components/eon-ui-components.css';

export const wrapRootElement = ({ element }) => (
  <GlobalContextProvider>{element}</GlobalContextProvider>
);